export const resultTypes = [
  { value: "boolean", label: "Sí / No / N/A" },
  { value: "approved", label: "Aprobó / Alerta / Falló" },
  { value: "number", label: "Número" },
  { value: "text", label: "Texto" },
  { value: "gps", label: "GPS" },
];
